function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { MetadataSelectors } from 'invision-core';
import Configurable from 'invision-core/src/components/configurable/configurable';
import { BusinessUnitCustomPagesTemplateSelector, BusinessUnitCustomWidgetsTemplateSelector, BusinessUnitFeatureToggleSelector, BusinessUnitFetchFeatureToggleValuesSelector, BusinessUnitHasTemplateSelector, BusinessUnitTemplateAndGroupTemplateSelector } from 'invision-core/src/components/configurable/configurable.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { IsConvergentBillerSelector } from 'invision-core/src/components/metadata/codes/codes.selectors.deprecated';
import { RouteCurrentStateSelector } from 'invision-core/src/components/router/router.selectors';
import { hasAccess, hasAdminAccess } from 'invision-core/src/components/security/permission.service';
import { CurrentBusinessUnitSelector, IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { OFFER_STATUS_INDICATOR_STATUS } from 'invision-core/src/constants/status.constants';
import find from 'ramda/src/find';
import partial from 'ramda/src/partial';
import propEq from 'ramda/src/propEq';
import values from 'ramda/src/values';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { CUSTOMER_CATEGORY } from '../../components/createCustomerPopup/create.customer.popup.constants';
import { ACCOUNT_HIERARCHY_PAGE, CUSTOMER_PAGES_MAP, DEMO_ACTIONS_PAGE, HOUSEHOLD_PAGE, PRODUCTS_PAGE, SUBSCRIPTIONS_PAGE } from '../../components/customerActionsTemplate/customer.pages';
import { GLOBAL_ACTIONS_MAP } from '../../components/customerActionsTemplate/global.actions';
import { QUICK_ACTIONS_MAP } from '../../components/customerActionsTemplate/quick.actions';
import { DISCONNECT_CUSTOMER_ACTION_STATE, DISCONNECT_RESTRICTED_REASON_TYPE, SUBSCRIBER_CATEGORY_CODES } from '../../customercare.constants';
import CustomerCareLocaleKeys from '../../locales/keys';
import { ALLOW_REMOVAL_OF_OFFERINGS, CASE_ACCESS, ORDER_HISTORY_ACCESS } from '../../security.attributes';
import { CustomerAccountStatusSelector } from './customer.account.status.selectors';
import { ConvergentBillerAccountOfferingsForSelectedAccountSelector, DisconnectRestrictedReasonTypeSelector, HasPrepaidAndPostpaidOffersSelector } from './customer.convergent.biller.selectors';
import { CurrentCustomerSelector, HasConvergentBillerIdSelector, IsCurrentCustomerBlocklisted, IsCurrentCustomerReadyForOrdersSelector, IsExistingCartSelector, IsExistingStoreOrderSelector, IsSelectedCustomerWithPinSelector, IsTransferCartFromCurrentCustomerSelector, RouteParams } from './customer.selectors';
import { GranularSecurityAccessFeatureVisibilitySelector } from './order.history.selectors';
import { IsCustomerWrapUpRequiredSelector } from './search.selectors';
var CUSTOMER_PAGE_IDS = Configurable.CustomerCare.CUSTOMER_PAGE_IDS;
export var CustomerActionsTemplateStoreSelector = function CustomerActionsTemplateStoreSelector(state) {
  return state.customercare.customerActionsTemplate;
};
export var SelectedNavGroupSelector = createSelector([CustomerActionsTemplateStoreSelector], function (actionsTemplate) {
  return actionsTemplate.selectedNavGroup;
});
export var CustomerTemplateSelector = createSelector([BusinessUnitHasTemplateSelector, BusinessUnitTemplateAndGroupTemplateSelector, IsDbss], function (hasTemplate, businessUnitTemplateAndGroupTemplate, isDbss) {
  return hasTemplate ? businessUnitTemplateAndGroupTemplate : isDbss ? Configurable.dbssTemplate : Configurable.ottTemplate;
});
var customerHasAccess = partial(function (securityAttributes, item) {
  return item && (!item.securityAttributes || item.securityAttributes.every(function (sa) {
    return hasAccess(securityAttributes, sa);
  })) && (!item.adminAttributes || item.adminAttributes.every(function (attribute) {
    return hasAdminAccess(securityAttributes, attribute);
  }));
});
var translateMap = function translateMap(map) {
  var translated = Immutable({});
  values(map).forEach(function (item) {
    translated = translated.set(item.id, item.set('label', i18n.translate(item.label)));
  });
  return translated;
};
var mergeSources = function mergeSources() {
  var orderOfItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var configurableMap = arguments.length > 1 ? arguments[1] : undefined;
  var customerCareMap = arguments.length > 2 ? arguments[2] : undefined;
  return orderOfItems.map(function (id) {
    return customerCareMap[id] ? customerCareMap[id].merge(configurableMap[id] || {}, {
      deep: true
    }) : id;
  });
};
export var BillingLedgerBetaUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvBillingLedgerBetaEnabled;
});
export var TransactionsBetaUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvTransactionsBetaEnabled;
});
export var TotalsBetaUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvTotalsBetaEnabled;
});
export var DevicesBetaUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvDevicesBetaEnabled;
});
export var SubscriptionsBetaUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvSubscriptionsBetaEnabled;
});

/**
 * Whether React serves the subscription change orders.
 *
 * Not a Beta toggle and not part of the subscriptions one: the subscription
 * pages can be on React while modify and replace still check out on Angular,
 * which is the whole point of shipping the wizard behind its own switch.
 */
export var SubscriptionChangeOrderFlowUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvReactSubscriptionChangeOrderFlow;
});

/**
 * Whether React serves Redeem Gift Order.
 *
 * Own switch, not InvReactItvProductOrderFlow: create-product can stay on
 * Angular while redeem runs on React (and the reverse). When ON,
 * getReactRoutes redirects the Angular redeemGiftOrder state to the React
 * page; when OFF, Angular keeps serving it.
 */
export var RedeemGiftOrderFlowUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvReactRedeemGiftOrderFlow;
});
export var CouponsBetaUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvCouponsBetaEnabled;
});
export var ContentActivityBetaUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvContentActivityBetaEnabled;
});
export var SalesPipelineFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvSalesPipelineEnabled;
});
export var MaskCreditCardNumberSelector = createSelector([BusinessUnitFeatureToggleSelector], function (featureToggle) {
  return featureToggle.InvMaskCreditCardNumberEnabled;
});
export var InvisionCareModuleNameCustomizationUIFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvCareModuleNameCustomizationEnabled;
});
export var InvEnableFinalInvoiceGenerationOnRootInvoiceNodeFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvEnableFinalInvoiceGenerationOnRootInvoiceNode;
});
export var InvEnableFinalInvoiceIndicatorDisplaySelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvEnableFinalInvoiceIndicatorDisplay;
});
export var ReactOrderItemDetailsToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvOrderItemDetails;
});
export var ReactHouseholdPageFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvReactHouseholdPageEnabled;
});
export var ReactCustomPageFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvReactCustomPageEnabled;
});
export var DisplayTransactionEmailAndPrintFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvDisplayEmailAndPrintTransaction;
});
export var HideTransactionItemsFeatureToggleSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvHideTransactionItemsEnabled;
});
export var InvEnablePaymentTransferSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvEnablePaymentTransfer;
});
export var InvEnableAutoApplyNoteToFutureInvoicesSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvEnableAutoApplyNoteToFutureInvoices;
});
export var InvEnableDiscountEffectiveDateSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvEnableDiscountEffectiveDate;
});
export var NoCustomWidgetsConfiguredSelector = createSelector([CustomerTemplateSelector], function (template) {
  return !(template.widgets && template.widgets.length > 0);
});
var EMPTY_ARRAY = [];
export var CustomerTemplateWidgetSelector = createSelector([CustomerTemplateSelector, BusinessUnitCustomWidgetsTemplateSelector, MetadataCodeSelector(CODES.BusinessUnitTemplate)], function (template, customWidgets, templateStore) {
  if (!template.widgets) {
    return EMPTY_ARRAY;
  }
  // because of the requests that the account status widget makes upon load, we will not load it until we have all the template information loaded.
  var templateLoadComplete = Boolean(templateStore && (templateStore.isLoaded || templateStore.error));
  var widgetList = [];
  template.widgets.map(function (widget) {
    var isSystemWidget = false;
    var displayAccountStatus = Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.ACCOUNT_STATUS === widget;
    var widgetDisplay = {
      displayAccountBalanceTreatment: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.BALANCE_AND_TREATMENT === widget && (isSystemWidget = true),
      displayAccountStatus: displayAccountStatus && templateLoadComplete && (isSystemWidget = true),
      displayActiveProducts: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.ACTIVE_PRODUCTS === widget && (isSystemWidget = true),
      displayDeviceFinancing: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.DEVICE_FINANCING === widget && (isSystemWidget = true),
      displayNextBestOffering: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.NEXT_BEST_OFFERING === widget && (isSystemWidget = true),
      displayOfferingDeprecated: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.OFFERING_DEPRECATED === widget && (isSystemWidget = true),
      displayOfferings: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.OFFERINGS === widget && (isSystemWidget = true),
      displayOpenInvoices: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.OPEN_INVOICES === widget && (isSystemWidget = true),
      displayProducts: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.PRODUCTS === widget && (isSystemWidget = true),
      displayServices: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.SERVICES === widget && (isSystemWidget = true),
      displayServicesDeprecated: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.SERVICES_DEPRECATED === widget && (isSystemWidget = true),
      displaySubscriptions: Configurable.CustomerCare.CUSTOMER_SYSTEM_WIDGET_IDS.SUBSCRIPTIONS === widget && (isSystemWidget = true)
    };
    if (!displayAccountStatus || templateLoadComplete) {
      widgetList.push(isSystemWidget ? widgetDisplay : Object.assign(widgetDisplay, {
        displayCustomWidget: customWidgets && Object.values(customWidgets).find(function (customWidget) {
          return customWidget.Id === widget;
        })
      }));
    }
  });
  var bothServiceAndOfferWidgetEnabled = [];
  widgetList.forEach(function (widget, index) {
    if (widget.displayServices) {
      bothServiceAndOfferWidgetEnabled.push({
        displayServices: widget.displayServices,
        index: index
      });
    }
    if (widget.displayOfferings) {
      bothServiceAndOfferWidgetEnabled.push({
        displayOfferings: widget.displayOfferings,
        index: index
      });
    }
  });
  if (bothServiceAndOfferWidgetEnabled.length > 1 && bothServiceAndOfferWidgetEnabled.every(function (widget) {
    return widget && widget.displayServices || widget.displayOfferings;
  })) {
    var widgetsSorted = bothServiceAndOfferWidgetEnabled.sort(function (widgetA, widgetB) {
      return widgetA.index - widgetB.index;
    });
    widgetList.splice(widgetsSorted[0].index, 0, {
      displayServicesAndOfferingsWidget: true
    });
    widgetList.find(function (widget) {
      if (widget.displayServices) {
        Object.assign(widget, {
          displayServices: false
        });
      }
      if (widget.displayOfferings) {
        Object.assign(widget, {
          displayOfferings: false
        });
      }
    });
  }
  return widgetList;
});
var mergeCustomPages = function mergeCustomPages(pageList) {
  var customPages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return pageList.map(function (page) {
    if (typeof page === 'string') {
      var matchingCustomPage = Object.values(customPages).find(function (customPage) {
        return customPage.Id === page;
      });
      if (matchingCustomPage) {
        return Immutable({
          id: matchingCustomPage.Id,
          label: matchingCustomPage.Title,
          state: 'index.customercare.customer.customPage',
          params: {
            pageId: matchingCustomPage.Id
          }
        });
      } else {
        return page;
      }
    }
    return page;
  });
};
export var CustomerPageSelector = createSelector([CustomerTemplateSelector, BusinessUnitCustomPagesTemplateSelector, RouteParams], function (template, customPages, routeParams) {
  var translatedConfigurablePages = translateMap(Configurable.CustomerCare.CUSTOMER_PAGES_MAP);
  var combined = mergeSources(template.pages, translatedConfigurablePages, CUSTOMER_PAGES_MAP);
  var combinedWithCustomPages = mergeCustomPages(combined, customPages);
  return combinedWithCustomPages.map(function (page) {
    return page.set('params', _objectSpread(_objectSpread({}, routeParams), page.params)).set('subNavigation', mergeSources(template.subNavigation[page.id], translatedConfigurablePages, CUSTOMER_PAGES_MAP));
  });
});
export var CustomerPageWithConditionalSecuritySelector = createSelector([CustomerPageSelector, GranularSecurityAccessFeatureVisibilitySelector], function (pages, isGranularSecurityEnabled) {
  return pages.map(function (page) {
    // Apply conditional security for Order History page based on feature toggle
    if (page.id === CUSTOMER_PAGE_IDS.ORDER_HISTORY) {
      if (isGranularSecurityEnabled) {
        // Feature enabled: apply ORDER_HISTORY_ACCESS security attribute
        return page.set('securityAttributes', [ORDER_HISTORY_ACCESS]);
      } else {
        // Feature disabled: no security (backward compatibility)
        return page.set('securityAttributes', undefined);
      }
    }
    return page;
  });
});
export var CustomFilteredCustomerPages = createSelector([CustomerPageWithConditionalSecuritySelector, CurrentBusinessUnitSelector, CurrentCustomerSelector, IsDbss, UserSecurityAttributesSelector], function (pages, currentBU, currentCustomer, isDbss, userSecurityAttributes) {
  return pages.filter(function (page) {
    switch (page.id) {
      case CUSTOMER_PAGE_IDS.HOUSEHOLD:
        return currentCustomer.Category !== CUSTOMER_CATEGORY.COMMERCIAL && currentBU && currentBU.householdEnabled;
      case CUSTOMER_PAGE_IDS.SERVICES:
        return isDbss;
      case CUSTOMER_PAGE_IDS.CASES:
        return hasAccess(userSecurityAttributes, CASE_ACCESS);
      default:
        return true;
    }
  });
});
export var FilteredCustomerPages = createSelector([CustomFilteredCustomerPages, UserSecurityAttributesSelector, HasConvergentBillerIdSelector, IsDbss], function (pages) {
  var securityAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var hasConvergentBillerId = arguments.length > 2 ? arguments[2] : undefined;
  var isDbss = arguments.length > 3 ? arguments[3] : undefined;
  var hasAccessForCurrentCustomer = customerHasAccess([securityAttributes]);
  return pages.filter(hasAccessForCurrentCustomer).map(function (page) {
    var modifiedPage = page;
    if (ACCOUNT_HIERARCHY_PAGE.id === modifiedPage.id || DEMO_ACTIONS_PAGE.id === modifiedPage.id || (HOUSEHOLD_PAGE.id === modifiedPage.id || PRODUCTS_PAGE.id === modifiedPage.id || SUBSCRIPTIONS_PAGE.id === modifiedPage.id) && isDbss) {
      modifiedPage = modifiedPage.set('isLocked', !hasConvergentBillerId);
      modifiedPage = modifiedPage.set('lockMessage', i18n.translate(modifiedPage.lockMessage));
    }
    if (modifiedPage.subNavigation) {
      modifiedPage = modifiedPage.set('subNavigation', modifiedPage.subNavigation.filter(hasAccessForCurrentCustomer));
    }
    return modifiedPage;
  });
});
var isChildRoute = function isChildRoute() {
  var subState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return subState.startsWith("".concat(routeName, "."));
};
export var FilteredCustomerPagesWithActiveRoute = createSelector([FilteredCustomerPages, SelectedNavGroupSelector, RouteCurrentStateSelector], function (pages, selectedNavGroup, currentState) {
  return pages.map(function (page) {
    return page.set('active', currentState && (currentState.name === page.state || isChildRoute(currentState.name, page.state) || page.subNavigation && page.subNavigation.some(function (_ref) {
      var state = _ref.state;
      return state === currentState.name;
    })) || selectedNavGroup === page.id);
  });
});
export var IsProfilePageEnabledSelector = createSelector([FilteredCustomerPagesWithActiveRoute], function (pages) {
  return pages && pages.some(function (page) {
    return page.id === CUSTOMER_PAGE_IDS.PROFILE;
  });
});
var CustomerQuickActionsSelector = function CustomerQuickActionsSelector() {
  return translateMap(Configurable.CustomerCare.QUICK_ACTIONS_MAP);
};
var CUSTOMER_QUICK_ACTION_IDS = Configurable.CustomerCare.CUSTOMER_QUICK_ACTION_IDS;
var LOCKED_PROPERTY = 'isLocked';
var offerOptionsActiveOrRemovedOrSuspended = function offerOptionsActiveOrRemovedOrSuspended(offer) {
  var hasOfferOptions = offer.Options && offer.Options.length > 0;

  //If there's no offer options just return true
  if (!hasOfferOptions) {
    return offer.Status === OFFER_STATUS_INDICATOR_STATUS.ACTIVE;
  } else {
    return offer.Options.every(function (option) {
      return OFFER_STATUS_INDICATOR_STATUS.ACTIVE === option.Status || OFFER_STATUS_INDICATOR_STATUS.REMOVED === option.Status || OFFER_STATUS_INDICATOR_STATUS.SUSPENDED === option.Status || OFFER_STATUS_INDICATOR_STATUS.PENDING_SUSPENSION === option.Status;
    });
  }
};
export var FilteredCustomerQuickActionsSelector = createSelector([CustomerTemplateSelector, CustomerQuickActionsSelector, UserSecurityAttributesSelector], function (template, quickActions) {
  var securityAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var hasAccessForCurrentCustomer = customerHasAccess([securityAttributes]);
  return mergeSources(template.quickActions, quickActions, QUICK_ACTIONS_MAP).filter(hasAccessForCurrentCustomer);
});
export var CustomerAccountStatusViewIsViewable = createSelector([CustomerTemplateWidgetSelector], function (widgetList) {
  var hasAccountStatus = false;
  if (widgetList) {
    widgetList.forEach(function (widget) {
      hasAccountStatus = widget.displayAccountStatus || hasAccountStatus;
    });
  }
  return hasAccountStatus;
});
var determineDisconnectCustomerActionState = function determineDisconnectCustomerActionState(disconnectRestrictedReasonType, isGranularSecurityEnabled, hasRemoveOfferAccess) {
  switch (disconnectRestrictedReasonType) {
    case DISCONNECT_RESTRICTED_REASON_TYPE.NONE:
      return DISCONNECT_CUSTOMER_ACTION_STATE.DISPLAY;
    case DISCONNECT_RESTRICTED_REASON_TYPE.MISSING_ORDERING_ACCESS:
      return DISCONNECT_CUSTOMER_ACTION_STATE.HIDDEN;
    case DISCONNECT_RESTRICTED_REASON_TYPE.MISSING_REMOVE_OFFER_ACCESS:
      if (isGranularSecurityEnabled && hasRemoveOfferAccess) {
        return DISCONNECT_CUSTOMER_ACTION_STATE.LOCKED;
      }
      return DISCONNECT_CUSTOMER_ACTION_STATE.HIDDEN;
    case DISCONNECT_RESTRICTED_REASON_TYPE.ALREADY_DISCONNECTED:
      return DISCONNECT_CUSTOMER_ACTION_STATE.HIDDEN;
    case DISCONNECT_RESTRICTED_REASON_TYPE.NO_CONVERGENT_BILLER_OFFERINGS:
      return DISCONNECT_CUSTOMER_ACTION_STATE.HIDDEN;
    default:
      return DISCONNECT_CUSTOMER_ACTION_STATE.DISPLAY;
  }
};
export var CustomFilteredCustomerQuickActionsSelector = createSelector([FilteredCustomerQuickActionsSelector, CustomerAccountStatusSelector, IsExistingCartSelector, UserSecurityAttributesSelector, IsCustomerWrapUpRequiredSelector, IsExistingStoreOrderSelector, IsTransferCartFromCurrentCustomerSelector, CurrentCustomerSelector, DisconnectRestrictedReasonTypeSelector, GranularSecurityAccessFeatureVisibilitySelector], function (actions, accountStatus, isExistingCart, userSecurityAttributes, isCustomerWrapUpRequired, isExistingStoreOrder, isTransferCart, currentCustomer, disconnectRestrictedReasonType, isGranularSecurityEnabled) {
  var hasRemoveOfferAccess = hasAccess(userSecurityAttributes, ALLOW_REMOVAL_OF_OFFERINGS);
  var disconnectCustomerActionState = determineDisconnectCustomerActionState(disconnectRestrictedReasonType, isGranularSecurityEnabled, hasRemoveOfferAccess);
  return actions.filter(function (item) {
    switch (item.id) {
      case CUSTOMER_QUICK_ACTION_IDS.DISCONNECT_CUSTOMER:
        return disconnectCustomerActionState !== DISCONNECT_CUSTOMER_ACTION_STATE.HIDDEN;
      case CUSTOMER_QUICK_ACTION_IDS.RESET_DEVICE_PIN:
        return accountStatus && accountStatus.DeviceSessionPromotionPinExists;
      case CUSTOMER_QUICK_ACTION_IDS.RESUME_ORDER:
      case CUSTOMER_QUICK_ACTION_IDS.CLEAR_SAVED_CART:
        return isExistingCart && !isTransferCart;
      case CUSTOMER_QUICK_ACTION_IDS.REVIEW_STORE_ORDER:
      case CUSTOMER_QUICK_ACTION_IDS.CANCEL_STORE_ORDER:
        return isExistingStoreOrder;
      case CUSTOMER_QUICK_ACTION_IDS.UNREVOKE_LOGIN:
        return accountStatus && accountStatus.LoginRevoked;
      case CUSTOMER_QUICK_ACTION_IDS.OPEN_CASE:
        return hasAdminAccess(userSecurityAttributes, CASE_ACCESS);
      case CUSTOMER_QUICK_ACTION_IDS.CUSTOMER_WRAP_UP:
        return isCustomerWrapUpRequired;
      case CUSTOMER_QUICK_ACTION_IDS.CHANGE_BILLING_TYPE:
        return currentCustomer === null || currentCustomer === void 0 ? void 0 : currentCustomer.HierarchyParentSubscriberId;
      case CUSTOMER_QUICK_ACTION_IDS.MANAGE_SERVICES:
        return (currentCustomer === null || currentCustomer === void 0 ? void 0 : currentCustomer.Id) && (currentCustomer === null || currentCustomer === void 0 ? void 0 : currentCustomer.HierarchyId);
      case CUSTOMER_QUICK_ACTION_IDS.CREATE_COMMERCIAL_CHILD:
        return (currentCustomer === null || currentCustomer === void 0 ? void 0 : currentCustomer.Id) && (currentCustomer === null || currentCustomer === void 0 ? void 0 : currentCustomer.HierarchyId);
      default:
        return true;
    }
  });
});
export var AccountOfferingsSelector = createSelector([IsDbss, ConvergentBillerAccountOfferingsForSelectedAccountSelector], function (isDbss, dbssOfferings) {
  return dbssOfferings || EMPTY_ARRAY;
});
export var FilteredQuickActionsWithLocked = createSelector([AccountOfferingsSelector, CustomFilteredCustomerQuickActionsSelector, HasConvergentBillerIdSelector, IsConvergentBillerSelector, IsCurrentCustomerBlocklisted, HasPrepaidAndPostpaidOffersSelector, IsSelectedCustomerWithPinSelector, IsCurrentCustomerReadyForOrdersSelector, DisconnectRestrictedReasonTypeSelector, GranularSecurityAccessFeatureVisibilitySelector, UserSecurityAttributesSelector], function (currentOfferings, quickActions, hasConvergentBillerId, isConvergentBillerBU, isCurrentCustomerBlocklisted, hasPrepaidAndPostpaid, customerHasPIN, isCurrentCustomerReadyForOrders, disconnectRestrictedReasonType, isGranularSecurityEnabled, userSecurityAttributes) {
  var hasRemoveOfferAccess = hasAccess(userSecurityAttributes, ALLOW_REMOVAL_OF_OFFERINGS);
  var disconnectCustomerActionState = determineDisconnectCustomerActionState(disconnectRestrictedReasonType, isGranularSecurityEnabled, hasRemoveOfferAccess);
  return quickActions.map(function (item) {
    var completedItem;
    var lockMessage = item.lockMessage;
    switch (item.id) {
      case CUSTOMER_QUICK_ACTION_IDS.NEW_DBSS_ORDER:
        completedItem = item.set(LOCKED_PROPERTY, !isCurrentCustomerReadyForOrders);
        if (!completedItem[LOCKED_PROPERTY] && isCurrentCustomerBlocklisted) {
          completedItem = item.set(LOCKED_PROPERTY, isCurrentCustomerBlocklisted);
          lockMessage = CustomerCareLocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_STATUS_BLOCKLISTED_LOCKED_ORDERING;
        }
        break;
      case CUSTOMER_QUICK_ACTION_IDS.REDEEM_GIFT_ORDER:
        completedItem = item.set(LOCKED_PROPERTY, isCurrentCustomerBlocklisted);
        if (isCurrentCustomerBlocklisted) {
          lockMessage = CustomerCareLocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_STATUS_BLOCKLISTED_LOCKED_ORDERING;
        }
        break;
      case CUSTOMER_QUICK_ACTION_IDS.DISCONNECT_CUSTOMER:
        {
          var hasMultipleContracts = currentOfferings ? currentOfferings.filter(function (offering) {
            return offering.OrderContractInstance;
          }).length > 1 : false;
          var isEveryOfferOptionActiveOrRemovedOrSuspended = currentOfferings && currentOfferings.every(offerOptionsActiveOrRemovedOrSuspended);
          var isLockedDueToSalesChannel = disconnectCustomerActionState === DISCONNECT_CUSTOMER_ACTION_STATE.LOCKED;
          if (isLockedDueToSalesChannel && isEveryOfferOptionActiveOrRemovedOrSuspended) {
            lockMessage = CustomerCareLocaleKeys.MISSING_SALES_CHANNEL_FOR_DISCONNECT;
          } else if (hasMultipleContracts && !isEveryOfferOptionActiveOrRemovedOrSuspended) {
            lockMessage = CustomerCareLocaleKeys.MULTIPLE_CONTRACTS_CAN_NOT_FULL_DISCONNECT;
          } else if (hasPrepaidAndPostpaid) {
            lockMessage = CustomerCareLocaleKeys.PRE_AND_POSTPAID_OFFERS_CAN_NOT_FULL_DISCONNECT;
          }
          completedItem = item.set(LOCKED_PROPERTY, isLockedDueToSalesChannel || !isEveryOfferOptionActiveOrRemovedOrSuspended || hasMultipleContracts || hasPrepaidAndPostpaid);
          break;
        }
      case CUSTOMER_QUICK_ACTION_IDS.NEW_PRODUCT_ORDER:
        completedItem = item.set(LOCKED_PROPERTY, !isCurrentCustomerReadyForOrders);
        if (!completedItem[LOCKED_PROPERTY] && isCurrentCustomerBlocklisted) {
          completedItem = item.set(LOCKED_PROPERTY, isCurrentCustomerBlocklisted);
          lockMessage = CustomerCareLocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_STATUS_BLOCKLISTED_LOCKED_ORDERING;
        }
        break;
      case CUSTOMER_QUICK_ACTION_IDS.START_NEW_SUBSCRIPTION:
        completedItem = item.set(LOCKED_PROPERTY, isConvergentBillerBU ? !hasConvergentBillerId : false);
        if (!completedItem[LOCKED_PROPERTY] && isCurrentCustomerBlocklisted) {
          completedItem = item.set(LOCKED_PROPERTY, isCurrentCustomerBlocklisted);
          lockMessage = CustomerCareLocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_STATUS_BLOCKLISTED_LOCKED_ORDERING;
        }
        break;
      case CUSTOMER_QUICK_ACTION_IDS.VALIDATE_PIN:
        completedItem = item.set(LOCKED_PROPERTY, !customerHasPIN);
        if (!customerHasPIN) {
          lockMessage = CustomerCareLocaleKeys.CUSTOMER_DASHBOARD.VALIDATE_PIN_LOCK_MESSAGE;
        }
        break;
      default:
        completedItem = item;
        break;
    }
    return item.id ? completedItem.set('lockMessage', i18n.translate(lockMessage)) : item;
  });
});
var CustomerGlobalActionsSelector = function CustomerGlobalActionsSelector() {
  return translateMap(Configurable.CustomerCare.GLOBAL_ACTIONS_MAP);
};
var getValueFromAdditionalProperty = function getValueFromAdditionalProperty(key, object) {
  return find(propEq(key, 'Key'))(object.AdditionalProperties).Value;
};
var IsGuestCustomerTypeAvailableSelector = createSelector([MetadataCodeSelector(CODES.SubscriberType)], function (subscriberTypes) {
  return ((subscriberTypes === null || subscriberTypes === void 0 ? void 0 : subscriberTypes.items) || EMPTY_ARRAY).some(function (item) {
    var subscriberCategoryCode = getValueFromAdditionalProperty('subscriber_category_code', item);
    var enforceSubscriberMinimalInformation = getValueFromAdditionalProperty('enforce_subscriber_minimal_information', item);
    var isResidential = subscriberCategoryCode === SUBSCRIBER_CATEGORY_CODES.RESIDENTIAL.toString();
    var hasMinimalInfo = (enforceSubscriberMinimalInformation === null || enforceSubscriberMinimalInformation === void 0 ? void 0 : enforceSubscriberMinimalInformation.toLowerCase()) === 'true';
    return isResidential && hasMinimalInfo && item.Value;
  });
});
var FilteredCustomerGlobalActionsSelector = createSelector([CustomerTemplateSelector, CustomerGlobalActionsSelector, UserSecurityAttributesSelector, IsGuestCustomerTypeAvailableSelector], function (template, globalActions) {
  var securityAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isGuestCustomerTypeAvailable = arguments.length > 3 ? arguments[3] : undefined;
  var hasAccessForCurrentCustomer = customerHasAccess([securityAttributes]);
  return mergeSources(template.globalActions, globalActions, GLOBAL_ACTIONS_MAP).filter(hasAccessForCurrentCustomer);

  // Remove guest checkout if guest customer type is not available
  if (!isGuestCustomerTypeAvailable) {
    actions = actions.filter(function (action) {
      return action.id !== 'guest_checkout';
    });
  }
  return actions;
});
export var CustomerActionsTemplateSelector = createSelector([FilteredCustomerGlobalActionsSelector, FilteredCustomerPagesWithActiveRoute, FilteredQuickActionsWithLocked], function (globalActions, pages, quickActions) {
  return {
    globalActions: globalActions,
    pages: pages,
    quickActions: quickActions
  };
});
export var NonTelcoUsageServiceFeatureToggleSelector = createSelector([MetadataSelectors.codes.MetadataCodeTypeSelector(CODES.FeatureToggleConfig)], function (feaureToggleCodes) {
  if (feaureToggleCodes !== null && feaureToggleCodes !== void 0 && feaureToggleCodes.length) {
    var _findAdditonalPropert, _nonTelcoFeatureCodes, _findAdditonalPropert2, _nonTelcoFeatureCodes2;
    var nonTelcoFeatureCodes = feaureToggleCodes.filter(function (featureToggleCode) {
      return findAdditonalProperty(featureToggleCode === null || featureToggleCode === void 0 ? void 0 : featureToggleCode.AdditionalProperties, 'EnableFinancialBankingUsageDetails', 'Value');
    });
    var isNonTelcoFeatureEnabled = ((_findAdditonalPropert = findAdditonalProperty(nonTelcoFeatureCodes === null || nonTelcoFeatureCodes === void 0 ? void 0 : (_nonTelcoFeatureCodes = nonTelcoFeatureCodes.find(function (nonTelcoFeatureCode) {
      return !nonTelcoFeatureCode.hasOwnProperty('Global');
    })) === null || _nonTelcoFeatureCodes === void 0 ? void 0 : _nonTelcoFeatureCodes.AdditionalProperties, 'enabled')) === null || _findAdditonalPropert === void 0 ? void 0 : _findAdditonalPropert.Value) === 'True' ? true : false;
    var isNonTelcoFeatureGlobalValue = ((_findAdditonalPropert2 = findAdditonalProperty(nonTelcoFeatureCodes === null || nonTelcoFeatureCodes === void 0 ? void 0 : (_nonTelcoFeatureCodes2 = nonTelcoFeatureCodes.find(function (nonTelcoFeatureCode) {
      return nonTelcoFeatureCode.hasOwnProperty('Global');
    })) === null || _nonTelcoFeatureCodes2 === void 0 ? void 0 : _nonTelcoFeatureCodes2.AdditionalProperties, 'enabled')) === null || _findAdditonalPropert2 === void 0 ? void 0 : _findAdditonalPropert2.Value) === 'True' ? true : false;
    return isNonTelcoFeatureEnabled || isNonTelcoFeatureGlobalValue;
  }
  return false;
});
export function findAdditonalProperty(additionalProperties, targetProperty) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Key';
  var findProperty = function findProperty(property) {
    return property[type] === targetProperty;
  };
  return additionalProperties === null || additionalProperties === void 0 ? void 0 : additionalProperties.find(findProperty);
}